<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  @if (showContactInfo) {
    <div class="d-flex align-items-center" data-qa="test-contact-instructions">
      <div class="icon-container me-2">
        <rx-icon name="support" fill="primary-dark" />
      </div>
      <p class="m-0" [innerHTML]="t('contactInstructions', contactInstructionsHtmlParams())"></p>
    </div>
  }
</ng-container>